/** Shared field styles for public auth surfaces (login + /demo signup). */
export const AUTH_INPUT_CLASS =
  "mt-1 block w-full rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-sm text-slate-900 placeholder:text-slate-400 shadow-sm focus:border-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500/25";

export const AUTH_LINK_CLASS =
  "text-sm font-medium text-blue-700 hover:text-blue-600";
